const EventManager = {
  events: {},
  hooks: {
    emit: []
  },
  lockedEvents: [],
  lock (events: string | string[]) {
    const eventsToLock = typeof events === "string" ? [events] : events
    eventsToLock.forEach(event => {
      if (this.lockedEvents.indexOf(event) < 0) {
        this.lockedEvents.push(event)
      }
    })
  },
  unlock (events: string | string[]) {
    const eventsToUnlock = typeof events === "string" ? [events] : events
    eventsToUnlock.forEach( event => {
      let index = this.lockedEvents.indexOf(event)
      if (index > -1) {
        this.lockedEvents.splice(index, 1)
      }
    })
  },
  on (event: string, callback: Function) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback);

  },
  off (event: string, callback?: Function) {
    if (!this.events[event]) return;
    if (typeof callback === 'undefined') {
      delete this.events[event];
      return;
    }
    let index = this.events[event].indexOf(callback);
    if (index > -1) {
      this.events[event].splice(index, 1);
    } else {
      throw new Error('Callback not found')
    }
  },
  emit (event: string, ...data: any) {
    this.hooks.emit.forEach( hook => { hook(event, ...data) })
    if (!this.events[event]) return;
    if (this.lockedEvents.indexOf(event) > -1) return;
    this.events[event].forEach(subscriberCallback => subscriberCallback(...data));
  }
};

EventManager.hooks.emit.push((event) => { console.log(event) })

// @ts-ignore
if (process.env.NODE_ENV === 'development') {
  // @ts-ignore
  window.eventManager = EventManager;
}

export default EventManager;
